import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Table, Tag } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { InvoiceRequest, ShippedDateRequest } from 'libs/shared-models/sale-management/src/lib/sale-order/invoice-reqest';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import { PlantsDropDown } from '@gtpl/shared-models/masters';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { PurchasesProductService } from '@gtpl/shared-services/finance';


export const ShippedOrderReports = () => {
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState<number>(100);
  const service = new SaleOrderService();
  const [data, setData] = useState<any[]>([]);
  const [form] = Form.useForm();
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [filterData, setFilterData] = useState([]);
  const [invoiceNumbers, setInvoiceNumbers] = useState<any[]>([]);
  const searchInput = useRef(null);
  const [searchedColumn, setSearchedColumn] = useState('');
  const [searchText, setSearchText] = useState('');
const [isFilter,SetisFilter] = useState(false);
  const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
  const unitsService = new UnitcodeService();
  const [unitId, setUnitId] = useState<number>(0);
const [factoriesData, setFactoriesData] = useState([]);
  const purchaseService = new PurchasesProductService()
  useEffect(() => {
    // getInfo();
    getInvoiceNumbers();
    getAllCompanyNames();
    getAllPlants();
    if (Number(localStorage.getItem('unit_id')) != 5) {
      form.setFieldsValue({ unitId: Number(localStorage.getItem('unit_id')) })
  }
  }, []);
const poNumber=form.getFieldValue('poNumber')
  const getInfo = () => {
    const req = new ShippedDateRequest();

    if (form.getFieldValue("PoNumber") !== undefined) {
      req.poNumber = form.getFieldValue("PoNumber");
    }
    if (form.getFieldValue("companyId") !== undefined) {
      req.companyId = form.getFieldValue("companyId");
    }
    if (form.getFieldValue('shipmentDate') !== undefined) {
        req.shipmentDateStartDate = (form.getFieldValue('shipmentDate')[0]).format('YYYY-MM-DD');
      }
      if (form.getFieldValue('shipmentDate') !== undefined) {
        req.shipmentDateEndDate = (form.getFieldValue('shipmentDate')[1]).format('YYYY-MM-DD');
      }
      if (form.getFieldValue('invoiceDate') !== undefined) {
        req.invoiceStartDate = (form.getFieldValue('invoiceDate')[0]).format('YYYY-MM-DD');
      }
      if (form.getFieldValue('invoiceDate') !== undefined) {
        req.invoiceEndDate = (form.getFieldValue('invoiceDate')[1]).format('YYYY-MM-DD');
      }
      if (Number(localStorage.getItem('unit_id')) != 5) {
        req.unitId = Number(localStorage.getItem('unit_id'));
    } else {
        req.unitId = unitId
    }

      service.getShippedOrdersReport(req).then((res) => {
        
        if (res.status) {
          const sortedData = res.data?.sort((a, b) => 
            (a.invoiceNumber || '')?.localeCompare(b.invoiceNumber || '')
        );
          setData(sortedData);
          setFilterData(sortedData);
        } else {
          setData([]);
          setFilterData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }).catch(err => {
        setData([]);
        setFilterData([]);
        AlertMessages.getErrorMessage(err.message);
      });
    
  };
    const getAllPlants = () => {
      unitsService.getAllMainPlants().then((res) => {
          if (res.status) {
              setPlantData(res.data);
          } else {
              setPlantData([]);
          }
      }).catch(err => {
          AlertMessages.getErrorMessage(err.message);
          setPlantData([]);
      })
  }
  const handleUnit = (value) => {
    setUnitId(value)
  }
  const getAllCompanyNames = () => {
    purchaseService.getAllCompanys().then((res) => {
        if (res.status) {
            setFactoriesData(res.data)
        }
    })
}
  const getInvoiceNumbers = () => {
    service.getDistinctPoNumbers({ unitId: Number(localStorage.getItem('unit_id')) }).then(res => {
      if (res.status) {
        setInvoiceNumbers(res.data);
      } else {
        setInvoiceNumbers([]);
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    })
  };

  const onFinish = (values: any) => {
    getInfo();
    SetisFilter(true)
  };

  const onReset = () => {
    form.resetFields(); 
    setData([]);        
    setFilterData([]); 
    SetisFilter(false) 
  };

  const flattenData = (data: any[]) => {
    const flatData: any[] = [];
    data.forEach((record, recordIndex) => {
      record.items.forEach((item, itemIndex) => {
        flatData.push({
          sNo: (page - 1) * pageSize + (recordIndex + 1) + pageSize * (page - 1),
          Unit: record.unitName ?? '-',
          PoNumber: record.PoNumber ?? '-',
          poDate: record.poDate ? moment(record.poDate).format('YYYY-MM-DD') : '-',
          customerName: record.customerName ?? '-',
          brandName: record.brandName ?? '-',
          countryName:record.countryName ?? '-',
          destinationName: record.destinationName ?? '-',
          variety: item.variety ?? '-',                   
          packMethodName: item.packMethodName ?? '-',     
          minGrade: item.minGrade ?? '-',
          maxGrade: item.maxGrade ?? '-',
          noOfCases: item.noOfCases ?? '-',     
          totalNoOfCases:record.totalNoOfCases ?? '-',         
          netWeight: item.netWeight ?? '-',  
          totalNetWeight: record.totalNetWeight ?? '-',           
          rateKg: item.rateKg ?? '-',                    
          amount: item.amount ?? '-',      
          totalAmount :record.totalAmount ?? '-',      
          shipmentDate: record.shipmentDate ? moment(record.shipmentDate).format('YYYY-MM-DD') : '-',
          paymentTerms:record.paymentTerms ?? '-',
          invoiceNumber:record.invoiceNumber ?? '-',
          invoiceDate:record.invoiceDate ?  moment(record.invoiceDate).format('YYYY-MM-DD') : '-'
          
        });
      });
    });
    return flatData;
  };


  const getColumnSearchProps = (dataIndex: any) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{  marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  const columns: any[] = [
    {
      title: 'S No',
      key: 'sno',
      width: 70,
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    {
      title: "Unit",
      dataIndex: "unitName",
      
      sorter: (a, b) => a.unitName?.localeCompare(b.unitName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('unitName')

  },
  {
    title: "Company",
    dataIndex: "companyName",
   
    sorter: (a, b) => a.companyName?.localeCompare(b.companyName),
    sortDirections: ['descend', 'ascend'],
    ...getColumnSearchProps('companyName')

},

    {
      title: 'PO Number',
      dataIndex: 'PoNumber',
      sorter: (a, b) => a.PoNumber?.localeCompare(b.PoNumber),
    sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record.PoNumber ? record.PoNumber : '-';
      },
      ...getColumnSearchProps('PoNumber'),

    },
    {
      title: 'PO Date',
      dataIndex: 'poDate',
      sorter: (a, b) => a.poDate?.localeCompare(b.poDate),
    sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record.poDate ? moment(record.poDate).format('YYYY-MM-DD') : '-';
      },

    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      
      render: (text: any, record: any) => {
        return record.customerName ? record.customerName : '-';
      },
      ...getColumnSearchProps('customerName'),

    },
    {
      title: 'Brand Name',
      dataIndex: 'brandName',
      
      render: (text: any, record: any) => {
        return record.brandName ? record.brandName : '-';
      },
      ...getColumnSearchProps('brandName'),


    },
    {
      title: 'Country Name',
      dataIndex: 'countryName',
      
      render: (text: any, record: any) => {
        return record.countryName ? record.countryName : '-';
      },
      ...getColumnSearchProps('countryName'),

    },
    {
      title: 'Port Name',
      dataIndex: 'destinationName',
      
      render: (text: any, record: any) => {
        return record.destinationName && record.countryName 
          ? `${record.destinationName} (${record.countryName})` 
          : record.destinationName || record.countryName || '-';
      },
      
      ...getColumnSearchProps('destinationName'),

    },
    {
      title: 'Variety',
      width: 180,
      
      dataIndex: 'variety',
      key: 'variety',
      // render: (text, record, index) => {
      //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
      //   return {
      //     children: <span>{text}</span>,
      //     props: {
      //       rowSpan: rowSpan,
      //     },
      //   };
      // },
      // ...getColumnSearchProps('variety'),
      sorter: (a, b) => {
        const varietyA = a.items?.[0]?.variety || ''; 
        const varietyB = b.items?.[0]?.variety || '';
        return varietyA.localeCompare(varietyB);
      },
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          const varietyParts = data?.variety?.split('-'); 
          const formattedVariety = varietyParts?.slice(0, 2)?.join('-'); // Keep only first two parts
      
          let tag = index !== record?.items.length - 1 ? (
            <hr style={{ marginTop: '0rem', marginBottom: '0rem' }} />
          ) : (
            <></>
          );
      
          return <>{formattedVariety} {tag}</>;
        });
      }
      

    },
    // {
    //   title: 'Pack Method Name',
      

    //   dataIndex: 'packMethodName',
    //   key: 'packMethodName',
    //   // render: (text, record, index) => {
    //   //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
    //   //   return {
    //   //     children: <span>{text}</span>,
    //   //     props: {
    //   //       rowSpan: rowSpan,
    //   //     },
    //   //   };
    //   // },
    //   sorter: (a, b) => {
    //     const packMethodNameA = a.items?.[0]?.packMethodName || ''; 
    //     const packMethodNameB = b.items?.[0]?.packMethodName || '';
    //     return packMethodNameA.localeCompare(packMethodNameB);
    //   },
    //   sortDirections: ['descend', 'ascend'],
    //   render: (text: any, record: any) => {
    //     return record?.items?.map((data, index) => {
    //       let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
    //       return <>{data?.packMethodName} {tag}</>

    //     });
    //   },


    // },
    // {
    //   title: 'Min grade',
    //   

    //   dataIndex: 'minGrade',
    //   key: 'minGrade',
    //   // render: (text, record, index) => {
    //   //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
    //   //   return {
    //   //     children: <span>{text}</span>,
    //   //     props: {
    //   //       rowSpan: rowSpan,
    //   //     },
    //   //   };
    //   // },

    //   render: (text: any, record: any) => {
    //     return record?.items?.map((data, index) => {
    //       let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
    //       return <>{data?.minGrade} {tag}</>

    //     });
    //   },
    // },
    // {
    //   title: 'Max grade',
    //   

    //   dataIndex: 'maxGrade',
    //   key: 'maxGrade',
    //   // render: (text, record, index) => {
    //   //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
    //   //   return {
    //   //     children: <span>{text}</span>,
    //   //     props: {
    //   //       rowSpan: rowSpan,
    //   //     },
    //   //   };
    //   // },

    //   render: (text: any, record: any) => {
    //     return record?.items?.map((data, index) => {
    //       let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
    //       return <>{data?.maxGrade} {tag}</>

    //     });
    //   },
    // },

    // {
    //   title: 'Size',
      
    //   dataIndex: 'grades',
    //   key: 'grades',
    //   sorter: (a, b) => {
    //     const minGradeA = a.items?.[0]?.minGrade ?? 0; 
    //     const minGradeB = b.items?.[0]?.minGrade ?? 0;
    //     return minGradeA - minGradeB;
    //   },
    //   sortDirections: ['descend', 'ascend'],
    //   render: (text: any, record: any) => {
    //     return record?.items?.map((data, index) => {
    //       let tag = index !== record?.items.length - 1 ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }} /> : <></>;
    //       return (
    //         <div>
    //           {data?.minGrade} / {data?.maxGrade}
    //           {tag}
    //         </div>
    //       );
    //     });
    //   },

    // },
    {
      title: 'No Of Packages',
      

      dataIndex: 'noOfCases',
      key: 'noOfCases',
      // render: (text, record, index) => {
      //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
      //   return {
      //     children: <span>{text}</span>,
      //     props: {
      //       rowSpan: rowSpan,
      //     },
      //   };
      // },
      sorter: (a, b) => (a.items?.[0]?.noOfCases ?? 0) - (b.items?.[0]?.noOfCases ?? 0),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
          return <>{Number(data?.noOfCases).toLocaleString('en-IN')} {tag}</>

        });
      },

    },
    {
      title: 'Total No.Of Packages',
      dataIndex: 'totalNoOfCases',
      
      sorter: (a, b) => (a.totalNoOfCases ?? 0) - (b.totalNoOfCases ?? 0),
  sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('totalNoOfCases'),
      render: (text, record) => {
        return <span>{isNaN(Number(text)) ? '-' : Number(text).toLocaleString('en-IN')}</span>
      }
    },
    {
      title: 'Weight in Kgs',
      

      dataIndex: 'netWeight',
      key: 'netWeight',
      // render: (text, record, index) => {
      //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
      //   return {
      //     children: <span>{text}</span>,
      //     props: {
      //       rowSpan: rowSpan,
      //     },
      //   };
      // },
      sorter: (a, b) => (a.items?.[0]?.netWeight ?? 0) - (b.items?.[0]?.netWeight ?? 0),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
          return <>{Number(data?.netWeight).toLocaleString('en-IN')} {tag}</>

        });
      },
        // sorter: (a, b) => Number(a.netWeight) - Number(b.netWeight),
        // sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Total Weight',
      dataIndex: 'totalNetWeight',
      sorter: (a, b) => a.totalNetWeight - b.totalNetWeight,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        return <span>{isNaN(Number(text)) ? '-' : Number(text).toLocaleString('en-IN')}</span>
      },
    },
    {
      title: 'Rate /Kg',
      

      dataIndex: 'rateKg',
      key: 'rateKg',
      // render: (text, record, index) => {
      //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
      //   return {
      //     children: <span>{text}</span>,
      //     props: {
      //       rowSpan: rowSpan,
      //     },
      //   };
      // },
      sorter: (a, b) => (a.items?.[0]?.rateKg ?? 0) - (b.items?.[0]?.rateKg ?? 0),
  sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
          return <>{Number(data?.rateKg).toLocaleString('en-IN')} {tag}</>

        });
      },
      // sorter: (a, b) => a.rateKg - b.rateKg,
      // sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Amount',
      

      dataIndex: 'amount',
      key: 'amount',
      // render: (text, record, index) => {
      //   const rowSpan = index === 0 ? record?.items.length : 0; // Example: Merge first two rows
      //   return {
      //     children: <span>{text}</span>,
      //     props: {
      //       rowSpan: rowSpan,
      //     },
      //   };
      // },
      sorter: (a, b) => (a.items?.[0]?.amount ?? 0) - (b.items?.[0]?.amount ?? 0),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
          return <>{Number(data?.amount).toLocaleString('en-IN')} {tag}</>

        });
      },
      // sorter: (a, b) => a.amount - b.amount,
      // sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Total Amount',
      dataIndex: 'totalAmount',
      sorter: (a, b) => (a.totalAmount ?? 0) - (b.totalAmount ?? 0),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return<span> {isNaN(Number(text)) ? '-' : Number(text).toLocaleString('en-IN')}</span>
      },
    },
    {
      title: 'Shipment Date',
      dataIndex: 'shipmentDate',
      sorter: (a, b) => a.shipmentDate?.localeCompare(b.shipmentDate),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record.shipmentDate ? moment(record.shipmentDate).format('YYYY-MM-DD') : '-';
      },


    },
    {
      title: 'Payment Terms',
      dataIndex: 'paymentTerms',
      sorter: (a, b) => (a.paymentTerms ?? '').localeCompare(b.paymentTerms ?? ''),
  sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record.paymentTerms ? record.paymentTerms : '-';
      },
      ...getColumnSearchProps('paymentTerms'),

    },
    {
      title: 'Invoice Number',
      dataIndex: 'invoiceNumber',
      sorter: (a, b) => (a.invoiceNumber ?? '').localeCompare(b.invoiceNumber ?? ''),
      sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record.invoiceNumber ? record.invoiceNumber : '-';
      },
      ...getColumnSearchProps('invoiceNumber'),

    },
    {
      title: 'Invoice Date',
      dataIndex: 'invoiceDate',
      sorter: (a, b) => a.invoiceDate?.localeCompare(b.invoiceDate),
    sortDirections: ['descend', 'ascend'],
      render: (text: any, record: any) => {
        return record.invoiceDate ? moment(record.invoiceDate).format('YYYY-MM-DD') : '-';
      },

    },
    
    

  ];

  const headers = [
    'S.NO',
    "Unit",
    'Po Number',
    'Po Date',
    'Customer Name',
    'Brand Name',
    'Country Name',
    'Port Name',
    'Variety',
    // 'Size',
    'No Of Packages',
    'Total No.Of Packages',
    'Weight in Kgs',
    'Total Weight',
    'Rate /Kg',
    'Amount',
    'Total Amount',
    'Shipment Date',
    'Payment Terms',
    'Invoice Number',
    'Invoice Date'


  ];

      // Calculate Totals
    let totalCases = 0
    let totalWeight = 0
    let totalAmount = 0

    




  const exportExcel = () => {
    const flatData = flattenData(data);
  console.log(flatData,"!!!!!!!!!!!!!!!!!1")

  console.log(flatData,"ppooop")

     
     const exportData1 = flatData.map(item => {
      totalCases += Number(item.totalNoOfCases) || 0;
      totalWeight += Number(item.totalNetWeight) || 0;
      totalAmount += Number(item.totalAmount) || 0;
      console.log(item,"=====");
     })

    const exportData = flatData.map((item, index) => ({
      
      'S.NO': item.sNo,
      'Unit': item.Unit,
      'PO Number': item.PoNumber,
      'PO Date': item.poDate,
      'Customer Name': item.customerName,
      'Brand Name': item.brandName,
      'Country Name': item.countryName,
      'Port Name': item.destinationName,
      'Variety': item.variety ? item.variety.split('-').slice(0, 2).join('-') : '-',
      // 'Size': `${item.minGrade} / ${item.maxGrade}`,
      'No Of Packages': item.noOfCases,
      'Total No.Of Packages': item.totalNoOfCases,
      'Weight in Kgs': item.netWeight,
      'Total Weight': item.totalNetWeight,
      'Rate /Kg': item.rateKg,
      'Amount': item.amount,
      'Total Amount': item.totalAmount,
      'Shipment Date': item.shipmentDate,
      'Payment Terms': item.paymentTerms,
      'Invoice Number': item.invoiceNumber,
      'Invoice Date': item.invoiceDate
    }));
  

  
    // Append Total Row
    exportData.push({
      'S.NO':null ,
      'Unit': 'Total',
      'PO Number': '',
      'PO Date': '',
      'Customer Name': '',
      'Brand Name': '',
      'Country Name': '',
      'Port Name': '',
      'Variety': '',
      // 'Size': '',
      'No Of Packages': '',
      'Total No.Of Packages': totalCases,
      'Weight in Kgs': '',
      'Total Weight': totalWeight,
      'Rate /Kg': '',
      'Amount': '',
      'Total Amount': totalAmount,
      'Shipment Date': '',
      'Payment Terms': '',
      'Invoice Number': '',
      'Invoice Date': ''
    });
  
    const headers = Object.keys(exportData[0]);
  
    const worksheet = XLSX.utils.json_to_sheet(exportData, { header: headers });
  
    if (!worksheet['!rows']) worksheet['!rows'] = [];
    worksheet['!rows'][0] = { hpt: 45 };
  
    // Apply Borders
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!worksheet[cellAddress]) continue;
        if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
        worksheet[cellAddress].s.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' }
        };
      }
    }
  
    // Column Widths
    const colWidths = headers.map(header => ({
      wch: Math.max(
        header.length,
        ...exportData.map(row => (row[header] ? row[header].toString().length : 0))
      ) + 2 // Adding padding
    }));
    worksheet['!cols'] = colWidths;
  
    // Merge Cells for Common Values
    const mergeColumns = ['S.NO','Unit','PO Number', 'PO Date', 'Customer Name', 'Brand Name', 'Country Name','Total'];
    let lastMergeRow = {};
  
    mergeColumns.forEach(column => {
      lastMergeRow[column] = 1;
    });
  
    for (let i = 1; i < exportData.length; i++) {
      mergeColumns.forEach(column => {
        if (exportData[i][column] === exportData[i - 1][column]) {
          if (!worksheet['!merges']) worksheet['!merges'] = [];
  
          const colIndex = headers.indexOf(column);
          const mergeStart = lastMergeRow[column];
  
          worksheet['!merges'].push({
            s: { r: mergeStart, c: colIndex },
            e: { r: i, c: colIndex }
          });
  
          lastMergeRow[column] = mergeStart;
        } else {
          lastMergeRow[column] = i;
        }
      });
    }
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Shipped Orders Report');
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true
    });
  
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(dataBlob, 'shipped-orders-report.xlsx');
  };
  
  

  return (
    <>
    <style>
      {`
      .ant-card-head-title {
          display: inline-block;
          flex: 1;
          padding: 6px 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
      }
      
      `}
      </style>
        <Card
      title={<span style={{ color: 'white' }}>Shipped Orders Report</span>}
      extra={<Button onClick={exportExcel}>Get Excel</Button>}
      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={22}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item
                name="unitId"
                label="Unit"
                rules={[
                    {
                        required: false, message: 'Select Unit',
                    },
                ]}
            >
                <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Select Unit"
                    allowClear
                    style={{ width: '100%' }}
                    onChange={handleUnit}
                    disabled={Number(localStorage.getItem('unit_id')) != 5 ? true : false}
                >
                    {plantData.map(dropData => {
                        return <Option value={dropData.plantId}>{dropData.plantCode}</Option>
                    })}
                </Select>
            </Form.Item>
        </Col>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                        <Form.Item name="companyId" label="Company" >
                
                    
                            <Select
                                placeholder="Select Company"
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                allowClear
                                dropdownMatchSelectWidth={false}
        
                            >
                                {factoriesData.map(dropData => {
                                    console.log(factoriesData,'factoriesDatafactoriesDatafactoriesData')
                                    return <Option value={dropData.companyId}>{dropData.company}</Option>
                                })}
                            </Select>
                        </Form.Item>
                                    </Col>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                <Form.Item name="PoNumber" label="PO Number">
                  <Select
                    showSearch
                    placeholder="Select PO Number"
                    optionFilterProp="children"
                    allowClear
          
                  >
                    {invoiceNumbers.map((inc: any) => {
                      return (
                        <Option key={inc.PoNumber} value={inc.PoNumber}>
                          {inc.PoNumber}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
          <Form.Item label="Shipment Date" name="shipmentDate">
              <RangePicker  />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
          <Form.Item label="Invoice Date" name="invoiceDate"  rules={[{ required: true, message: 'Invoice Date is required' }]}>
              <RangePicker  />
            </Form.Item>
          </Col>
          <Col style={{ paddingLeft: '10px', marginTop: '30px' }}>               
          <Form.Item>
              <Button type="primary" htmlType="submit">
                Get Report
              </Button>
            </Form.Item>
          </Col>
          <Col style={{ paddingLeft: '10px', marginTop: '30px' }}>               
          <Form.Item>
              <Button type="primary" htmlType="reset" onClick={onReset}>
                Reset
              </Button>
            </Form.Item>
          </Col>
        </Row>
        {isFilter&&(
        <>
          {/* <Row gutter={16}>
            <Col>
              <Card
                title={`Total : ${filterData.length}`}
                style={{
                  textAlign: 'left',
                  width: 150,
                  height: 41,
                  backgroundColor: '#bfbfbf',
                }}
              />
            </Col>

            <Col>
              <Card
                title={`POs: ${
                  new Set(filterData.map((item) => item.PoNumber).filter(Boolean)).size
                }`}
                style={{
                  textAlign: 'left',
                  width: 150,
                  height: 41,
                  backgroundColor: '#bfbfbf',
                }}
              />
            </Col>
          </Row> */}
          <Row gutter={16} style={{height:'45px'}}>
            <Col span={5}>
              <Tag color="#bfbfbf" style={{ display: 'flex', color: 'black', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
                Total No.Of Shipped Orders: {data.length}
              </Tag></Col>
              <Col span={3}>
              <Tag color="#a9b9a2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              No.Of PO's: {new Set(data.map((record: any) => record.PoNumber).filter(Boolean)).size}
              </Tag></Col>
              <Col span={4}>
              <Tag color="#f2a637" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              No Of Countries : {new Set(data.map((record: any) => record.countryName).filter(Boolean)).size}
              </Tag></Col>
              <Col span={4}>
              <Tag color="#cb9860" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              Total No.Of Packages : {data.reduce((sum: number, record: any) => sum + (record.totalNoOfCases || 0), 0)}
              </Tag></Col>
              <Col span={5}>
              <Tag color="#738a6a" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              Total Weight :{data.reduce((sum: number, record: any) => sum + (record.totalNetWeight || 0), 0).toFixed(2)}
              </Tag></Col></Row>
              <Row gutter={16} style={{height:'45px'}}>
              <Col span={6}>
              <Tag color="#c2523c" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 35, padding: '6px' }}>
              Total Amount : {data.reduce((sum: number, record: any) => sum + (record.totalAmount || 0), 0).toFixed(2)}
              </Tag></Col>
              </Row>
          <Table
            bordered
            className="custom-table-wrapper"
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={filterData}
            size="small"
            pagination={{
              onChange(current) {
                setPage(current);
              }
            }}
             summary={(pageData) => {
              const totalNoOfCases = pageData.reduce((sum, record) => sum + (Number(record.totalNoOfCases) || 0), 0);
              const totalNetWeight = pageData.reduce((sum, record) => sum + (Number(record.totalNetWeight) || 0), 0);
              const totalAmount = pageData.reduce((sum, record) => sum + (Number(record.totalAmount) || 0), 0);
        
              return (
                
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}></Table.Summary.Cell>
                  <Table.Summary.Cell index={1}></Table.Summary.Cell>
                  <Table.Summary.Cell index={2}></Table.Summary.Cell>
                  <Table.Summary.Cell index={2}></Table.Summary.Cell>
                  <Table.Summary.Cell index={3}></Table.Summary.Cell>
                  <Table.Summary.Cell index={4} >Total</Table.Summary.Cell>
                  <Table.Summary.Cell index={5}></Table.Summary.Cell>
                  <Table.Summary.Cell index={6}></Table.Summary.Cell>
                  <Table.Summary.Cell index={7}></Table.Summary.Cell>
                  <Table.Summary.Cell index={8}></Table.Summary.Cell>
                  <Table.Summary.Cell index={9}></Table.Summary.Cell>
                  
                  <Table.Summary.Cell index={12} >{totalNoOfCases.toFixed(2)}</Table.Summary.Cell>
                  <Table.Summary.Cell index={13}></Table.Summary.Cell>
                  <Table.Summary.Cell index={14} >{totalNetWeight.toFixed(2)}</Table.Summary.Cell>
                  <Table.Summary.Cell index={15}></Table.Summary.Cell>
                  <Table.Summary.Cell index={16}></Table.Summary.Cell>
                  <Table.Summary.Cell index={17} >{totalAmount.toFixed(2)}</Table.Summary.Cell> 
                </Table.Summary.Row>
                
              );
            }}
          />
        </>
        )}
      </Form>
        </Card>
    </>
  );
};

export default ShippedOrderReports;
   

